import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async gerarLaudo ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: 'laudo/gerarLaudo',
      timeout: 180000,
      data: dados
    })
    return data
  },
  async getLaudosByFilter ({ commit }, dados) {
    if (dados.dados) {
      dados = dados.dados
    }
    const data = await axios({
      method: 'POST', url: 'laudo/findLaudosByFilter', data: {...dados}
    })
    return data
  },
  async getLaudosDto ({ commit }, ids) {
    const params = ids.map(id => `ids=${id}`).join('&')
    const data = await axios({
      method: 'GET',
      url: `laudo/getLaudosDto?${params}`
    })
    return data
  },
  async gerarPdf ({ commit }, ids) {
    const params = ids.map(id => `ids=${id}`).join('&')
    const data = await axios({
      method: 'POST',
      url: `laudo/gerarPdf?${params}`
    })
    return data
  },
  async update ({ commit }, laudo) {
    const data = await axios({
      method: 'PUT', url: 'laudo/update', data: laudo
    })
    return data
  },
  async findById ({ commit }, id) {
    const data = await axios({
      method: 'GET', url: `laudo/findById/${id}`
    })
    return data
  },
  async tramitarProcessoLaudo ({ commit }, id) {
    const data = await axios({
      method: 'GET', url: `laudo/tramitar/${id}`
    })
    return data
  },
  async findDocumentosByNumeroProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `laudo/findDocumentosByNumeroProcesso`,
      data: dados
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/diagnostico/diagnostico.js